import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./BMICalculator.css";
import FAQ from "./FAQs";
import BMICategories from "./BMIChart";
import BMICalculatorContent from "./BMICalculatorContent";
import BMIBlog from "./BMIBlog";

const BMICalculator = () => {
  const [weight, setWeight] = useState("");
  const [weightUnit, setWeightUnit] = useState("kgs");
  const [heightUnit, setHeightUnit] = useState("feet");
  const [heightFeet, setHeightFeet] = useState("");
  const [heightInches, setHeightInches] = useState("");
  const [bmi, setBmi] = useState(null);
  const [bmiCategory, setBmiCategory] = useState("");

  const calculateBMI = () => {
    let heightInMeters;
    let weightInKg;

    // Convert weight to kg based on selected weight unit
    if (weightUnit === "lbs" || weightUnit === "pounds") {
      weightInKg = weight * 0.453592; // lbs to kg
    } else if (weightUnit === "stones") {
      weightInKg = weight * 6.35029; // stones to kg
    } else {
      weightInKg = weight; // kg
    }

    // Calculate height in meters based on selected height unit
    if (heightUnit === "feet" && heightFeet) {
      const totalInches =
        parseInt(heightFeet) * 12 + parseInt(heightInches || 0);
      heightInMeters = totalInches * 0.0254; // inches to meters
    } else if (heightUnit === "inches" && heightInches) {
      heightInMeters = heightInches * 0.0254; // inches to meters
    } else if (heightUnit === "cm") {
      heightInMeters = heightInches / 100; // cm to meters
    } else {
      heightInMeters = heightInches; // already in meters
    }

    // Calculate BMI
    const calculatedBMI = weightInKg / (heightInMeters * heightInMeters);
    setBmi(calculatedBMI.toFixed(2));
    categorizeBMI(calculatedBMI.toFixed(1));
  };

  const categorizeBMI = (bmiValue) => {
    let category = "";
    if (bmiValue < 18.4) {
      category = "Underweight";
    } else if (bmiValue >= 18.4 && bmiValue < 24.9) {
      category = "Normal";
    } else if (bmiValue >= 24.9 && bmiValue < 39.9) {
      category = "Overweight";
    } else {
      category = "Obese";
    }
    setBmiCategory(category);
  };

  const clearFields = () => {
    setWeight("");
    setWeightUnit("kgs");
    setHeightUnit("feet");
    setHeightFeet("");
    setHeightInches("");
    setBmi(null);
    setBmiCategory("");
  };

  const isCalculateDisabled = !weight || !heightFeet;

  return (
    <div className="bmi-calculator">
      <Helmet>
        <title>GETFITFAST | BMI Calculator & Health Tips</title>
        <meta
          name="description"
          content="Welcome to the BMI Calculator. Calculate your BMI and find out how to maintain a healthy weight. Explore our health tips."
        />
      </Helmet>
      <div className="bmi-calculators" id="bmi-calculator">
        <div className="bmi-calculators-wrapper">
          <div>
          <h2 style={{display:"flex", justifyContent:"center"}}>BMI Calculator</h2>
          <div className="input-group">
            <label>Weight:</label>
            <input
              type="number"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              placeholder="Enter weight"
            />
            <select
              value={weightUnit}
              onChange={(e) => setWeightUnit(e.target.value)}
            >
              <option value="kgs">kg</option>
              <option value="lbs">lbs</option>
              <option value="stones">stones</option>
              <option value="pounds">pounds</option>
            </select>
          </div>
          <div className="input-group">
            <label>Height:</label>
            {heightUnit === "feet" && (
              <input
                type="number"
                value={heightFeet}
                onChange={(e) => setHeightFeet(e.target.value)}
                placeholder="Feet"
              />
            )}
            <input
              type="number"
              value={heightInches}
              onChange={(e) => setHeightInches(e.target.value)}
              placeholder={heightUnit === "feet" ? "Inches" : heightUnit}
            />
            <select
              value={heightUnit}
              onChange={(e) => {
                const unit = e.target.value;
                setHeightUnit(unit);
              }}
            >
              <option value="feet">feet</option>
              <option value="inches">inches</option>
              <option value="metres">metres</option>
              <option value="cm">cm</option>
            </select>
          </div>
          <div className="submit-group">
            <button onClick={calculateBMI} disabled={isCalculateDisabled}>
              Calculate
            </button>
            <button onClick={clearFields}>Clear</button>
          </div>
          <div className="bmi-result-container">
            <div className="bmi-result-header">Your BMI Result is:</div>
            <div className="bmi-result">
              <span className="bmi-value">BMI = {bmi}</span>{" "}
              {bmi && <span className="bmi-category">{bmiCategory}</span>}
            </div>
          </div>
          </div>
        </div>
        </div>
        <BMICategories />
        <BMICalculatorContent />
        <BMIBlog />
        <FAQ />
    </div>
  );
};

export default BMICalculator;
